var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('yetkidialog',{ref:"yetkidialog"}),_c('baseaktarim',{attrs:{"logo":'FHY',"title":'FREEBIRD Bilet ' + _vm.$t('Transfer'),"status":_vm.status},on:{"submitfile":_vm.SubmitFile},model:{value:(_vm.items),callback:function ($$v) {_vm.items=$$v},expression:"items"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }